import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses an httpOnly cookie set by the backend (no token in localStorage).
export const api = axios.create({ baseURL: API, withCredentials: true });

// Resolve an image reference to a full URL. Uploaded images are stored as
// relative "/api/files/..." paths; external stock images are absolute URLs.
export function resolveImg(url) {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url; // relative /api/files/...
}

export async function uploadReviewImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/reviews/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
